import request from '../../axios';

export const getBrandSaleAgent = async (brandId: number) => {
  const {data}: {data: BrandSaleAgentResponse} = await request.get(
    `api/v2/store/sale-agent/brand/${brandId}`,
  );

  return data.results;
};
